import type { IconNode } from '../types';

/**
 * @name whale-narwhal
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMjAgOS45OHMxLTMgMS03Yy0zIDItNSA2LTUgNi4wOCIgLz4KICA8cGF0aCBkPSJNNiA5LjcgMy45IDguNEMyLjcgNy43IDIgNi40IDIgNVYzYzIgMCA0IDIgNCAyczItMiA0LTJ2MmMwIDEuNC0uNyAyLjctMS45IDMuNGwtMy44IDIuNEE1IDUgMCAwIDAgNyAyMGgxMmMxLjcgMCAzLTEuMyAzLTN2LTNjMC0yLjgtMi4yLTUtNS01LTIuNyAwLTUuMSAxLjQtNi40IDMuNkw5LjcgMTRBMiAyIDAgMCAxIDYgMTNaIiAvPgogIDxwYXRoIGQ9Ik0xNSAxNWguMDEiIC8+Cjwvc3ZnPgo=) - https://lucide.dev/icons/whale-narwhal
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const whaleNarwhal: IconNode = [
  ['path', { d: 'M20 9.98s1-3 1-7c-3 2-5 6-5 6.08', key: '1oqhaz' }],
  [
    'path',
    {
      d: 'M6 9.7 3.9 8.4C2.7 7.7 2 6.4 2 5V3c2 0 4 2 4 2s2-2 4-2v2c0 1.4-.7 2.7-1.9 3.4l-3.8 2.4A5 5 0 0 0 7 20h12c1.7 0 3-1.3 3-3v-3c0-2.8-2.2-5-5-5-2.7 0-5.1 1.4-6.4 3.6L9.7 14A2 2 0 0 1 6 13Z',
      key: 'inpau9',
    },
  ],
  ['path', { d: 'M15 15h.01', key: 'lqbp3k' }],
];

export default whaleNarwhal;
